module.exports = __webpack_public_path__ + "img/CPTemp2.64281467.png";